export default "__VITE_ASSET__B8je5lZj__"